import {useRequest} from '@hooks'
import type {
    ClienteHttp,
    FollowUpAtualizacaoItemRequest,
    FollowUpFilialResponse,
    FollowUpItemOrdemCompraResponse,
    FollowUpItensOrdemCompraRequest,
    FollowUpOrdemCompraResponse,
    Identificador,
} from '../types'

const BASE_URL = '/follow-up/ordens-compra'

// Instanciado sob demanda (e não no topo do módulo) porque @services e @hooks
// se importam em ciclo (FollowUpService -> @hooks -> useRequest -> @services).
// Mesmo motivo descrito em AgendaExternaService.ts.
let cliente: ClienteHttp | undefined

function obterCliente(): ClienteHttp {
    // useRequest não é um hook React (não usa useState/useContext/etc.), é uma
    // fábrica que só coincide com o prefixo "use". A regra estática não sabe
    // disso e acusa chamada de hook fora de componente/hook.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    cliente ??= useRequest()
    return cliente
}

async function getOrdensCompra() {
    return obterCliente().get<FollowUpOrdemCompraResponse[]>(BASE_URL)
}

async function getItensOrdemCompra(requestDto: FollowUpItensOrdemCompraRequest) {
    return obterCliente().post<FollowUpItemOrdemCompraResponse[], FollowUpItensOrdemCompraRequest>(
        `${BASE_URL}/itens`, requestDto)
}

async function atualizarOrdemCompra(idOrdemCompra: Identificador, itens: FollowUpAtualizacaoItemRequest[]) {
    return obterCliente().put<void, FollowUpAtualizacaoItemRequest[]>(`${BASE_URL}/${idOrdemCompra}`, itens)
}

async function getFilialOrdemCompra(idOrdemCompra: Identificador) {
    return obterCliente().get<FollowUpFilialResponse>(`${BASE_URL}/filial/${idOrdemCompra}`)
}

export const followUpService = {
    getOrdensCompra,
    getItensOrdemCompra,
    atualizarOrdemCompra,
    getFilialOrdemCompra,
}
